import { OhlcvIndex, type StockData } from '../types/chart';
import type { MoreProps } from '../types/commontypes';

export function calculateTotalVolume(moreProps: MoreProps<StockData>, startX: number, endX: number) {
  const { xAccessor, plotData } = moreProps;

  const startIndex = plotData.findIndex((d: StockData) => xAccessor(d) === startX);
  const endIndex = plotData.findIndex((d: StockData) => xAccessor(d) === endX);

  if (startIndex === -1 || endIndex === -1) return 0;

  const [i0, i1] = startIndex < endIndex ? [startIndex, endIndex] : [endIndex, startIndex];

  const total = plotData.slice(i0, i1 + 1).reduce((sum: number, d: StockData) => {
    return sum + (d.ohlcv[OhlcvIndex.VOLUME] || 0);
  }, 0);

  return formatVolume(total);
}

export function formatVolume(vol: number): string {
  if (vol >= 1_000_000_000) return (vol / 1_000_000_000).toFixed(2) + 'B';
  if (vol >= 1_000_000) return (vol / 1_000_000).toFixed(2) + 'M';
  if (vol >= 1_000) return (vol / 1_000).toFixed(2) + 'K';
  return vol.toString();
}
